export function isMediaClientError(error) {
  return error instanceof Object && 'attributes' in error && error.attributes instanceof Object && 'reason' in error.attributes && error instanceof Error;
}
export function getMediaClientErrorReason(err) {
  return isMediaClientError(err) ? err.attributes.reason : 'unknown';
}